import { render, staticRenderFns } from "./CalendarRoute.vue?vue&type=template&id=064fee14&scoped=true"
import script from "./CalendarRoute.vue?vue&type=script&lang=ts"
export * from "./CalendarRoute.vue?vue&type=script&lang=ts"
import style0 from "./CalendarRoute.vue?vue&type=style&index=0&id=064fee14&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fee14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064fee14')) {
      api.createRecord('064fee14', component.options)
    } else {
      api.reload('064fee14', component.options)
    }
    module.hot.accept("./CalendarRoute.vue?vue&type=template&id=064fee14&scoped=true", function () {
      api.rerender('064fee14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/calendar/CalendarRoute.vue"
export default component.exports